import React, { useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import ArrowDownwardIcon from '@material-ui/icons/ArrowBackOutlined';
import { SnackbarKey, SnackbarProvider, useSnackbar } from 'notistack';
import { ErrorMessage, ErrorType } from '../Core/BaseResponse';
import { isNumber } from 'util';


export interface ToastControlProps {
  Messages: ErrorMessage[];
  OnToastEntered: (node: HTMLElement, isAppearing: boolean, key: SnackbarKey) => void;
}


function MyApp(props: ToastControlProps) {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    props.Messages.forEach((m, i) => {

      var tempValue = m.ErrorType.toString();

      if (isNumber(m.ErrorType)) {
        tempValue = ErrorType[m.ErrorType].toString();
      }
      var variant = tempValue.toLowerCase() as 'default' | 'error' | 'success' | 'warning' | 'info';
      //enqueueSnackbar(m.Message, { variant });  

      //Key not assigned to not to show suplicate message
      enqueueSnackbar(m.Message, { variant, key: m.Message });

    })
  })

  return (<></>
  );
}

export default function ToastControl(props: ToastControlProps) {
  const notistackRef = React.createRef<SnackbarProvider>();
  const onClickDismiss = (key: SnackbarKey) => () => {
    // @ts-ignore
    notistackRef.current.closeSnackbar(key);
  }
  return (
    <SnackbarProvider maxSnack={10} preventDuplicate={true} onEntered={props.OnToastEntered} ref={notistackRef} action={(key) => (
      <IconButton aria-label="delete" size="small" onClick={onClickDismiss(key)}>
        <ArrowDownwardIcon fontSize="inherit" />
      </IconButton>
    )}
    >

      <MyApp {...props} />
    </SnackbarProvider>
  );
}